import BaseFormPresenter from "../../../../base/BaseFormPresenter";

export default class RequestOvertimePresenter extends BaseFormPresenter {
  constructor(view) {
    super(view);
  }
}
